/**
 * This file serve as the JavaScript entrypoint to all web pages in Portal.
 * Use this file to load any non-React libraries or (if truly necessary) add
 * global functions.
 */

// Include the JavaScript to format and convert UTC timestamps to local
require("./datetime-to-local");

// Include the JavaScript to copy to clipboard
require("./copy-to-clipboard");

// Import the JavaScript functionality for the Bootstrap front-end library
import "bootstrap";

require("./offboard-banner"); // must be after bootstrap

// Needed so we can support async functions.
import "regenerator-runtime/runtime";

import { initSentry } from "./sentry";

initSentry();

// Add tooltips, if present
$('[data-toggle="tooltip"]').tooltip();

// Add Google Tag Manager for all pages
// See https://developers.google.com/tag-manager/quickstart
(function (w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != "dataLayer" ? "&l=" + l : "";
  j.async = true;
  j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
  f.parentNode.insertBefore(j, f);
})(window, document, "script", "dataLayer", "GTM-MX5544L");
